export default "__VITE_ASSET__1a1af6f1__"